<template>
    <div id="vtab" class="vTabs">
        <div class="v_tabs" style="display:flex;" :class="{ v_tabsActive: type == 60 || type == 999 }">
            <ul v-if="type != 60 && type != 999">
                <li v-if="(type >= 3 && type != 7 && type != 9||actionType=='审核修改') && (istitle == '器械操作记录' || istitle == '商品操作记录')" @click="tabs(istitle, -1)" :class="{ actives: activeName == istitle }">
                    <span>{{ istitle }}</span>
                </li>
                <li v-if="(type > 2||actionType=='审核修改') && istitle == '供应商操作记录'" @click="tabs(istitle, -1)" :class="{ actives: activeName == istitle }">
                    <span>{{ istitle }}</span>
                </li>
                <li v-if="(type > 2||actionType=='审核修改') && istitle == '客户操作记录'" @click="tabs(istitle, -1)" :class="{ actives: activeName == istitle }">
                    <span>{{ istitle }}</span>
                </li>
                 <li v-if="(type >= 2||actionType=='审核修改') && istitle == '操作记录'" @click="tabs(istitle, -1)" :class="{ actives: activeName == istitle }">
                    <span>{{ istitle }}</span>
                </li>
                <li v-for="(item, index) in tabslist" :key="index" @click="tabs(item[value], index)" v-if="item.isShowForm != 1&&(tabslist.length>1||tabShow)&&isFlag" :class="{ actives: activeName == item[value] }">
                    <span>{{ item[name] }}</span>
                </li>
            </ul>
            <ul v-else-if="type == 999&&tabslist1.length>1" class="ul">
                <li class="li" v-for="(item, index) in tabslist1" :key="index" @click="tabs(item[value], index)" v-if="item.isShowForm != 1" :class="{ actives: activeName == item[value] }">
                    <span>{{ item[name] }}</span>
                </li>
            </ul>
            <ul v-else-if="tabslist.length>1||tabShow" class="ul">
                <li class="li" v-for="(item, index) in tabslist" :key="index" @click="tabs('report' + index, index,)" v-if="item.isShowForm != 1" :class="{ actives: activeName == 'report' + index }">
                    <span>{{ item[name] }}</span>
                </li>
            </ul>

            <ul class="ul_btn" v-if="type == 60">
                <slot name="btn"></slot>
                <li v-if="isSet">
                    <el-tooltip class="item" effect="dark" content="设置" placement="top">
                        <i class="el-icon-setting icons" @click="openFormDesign"></i>
                    </el-tooltip>
                </li>
            </ul>
            <ul class="ul_btn" v-else-if="type != 2 && type != 99">
                <li v-if="!tablefixed && type == 999">
                    <i class="el-icon-setting icons" @click="openFormDesign"></i>
                </li>
            </ul>
        </div>
        <div v-if="type != 60" class="v_tabs_bottom" v-show="index == -1">
            <slot name="tabs" :index="-1"></slot>
        </div>
        <div class="v_tabs_bottom" v-for="(item, index1) in list" :key="index1" v-show="index == index1" v-if="item.isShowForm != 1 && flag">
            <slot name="tabs" :row="item" :index="index1"></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: "vTabs",
    props: {
        istitle: {
            type: String,
            default: () => {
                return ""
            }
        },
        tablefixed: {
            type: Boolean,
            default: () => {
                return false
            }
        },
        tabShow: {
            type: Boolean,
            default: () => {
                return false
            }
        },
        //数据
        tabslist: {
            type: Array,
            default: () => {
                return []
            }
        },
        //数据
        tabsTitle: {
            type: String,
            default: () => {
                return ""
            }
        },
        //选中的名称
        activeName: {
            type: String,
            default: () => {
                return ""
            }
        },
        //展示的字段
        name: {
            type: String,
            default: () => {
                return ""
            }
        },
        //索引字段
        value: {
            type: String,
            default: () => {
                return ""
            }
        },
        //状态 0（新增）   1（修改）   2（查看）
        type: {
            type: Number,
            default: () => {
                return 0
            }
        },
        //状态 是否审核时需要修改
        actionType: {
            type: String,
            default: () => {
                return ""
            }
        },
        isSet: {
            type: Boolean,
            default: () => {
                return true
            }
        },
        isFlag: {
            type: Boolean,
            default: () => {
                return true
            }
        }

    },
    data() {
        return {
            index: 0,
            list: [],
            tabslist1: [],
            flag: false,
        }
    },
    watch: {
        "$store.state.actionMenu": {
            handler: function (newValue, oldValue) {
                console.log(newValue, oldValue);
            },
            deep: true,
        },
    },
    created() {

    },
    methods: {
        tabs(value, index) {
            this.index = index
            this.$emit("tabs", value)
            this.$nextTick(() => {
                if (this.type == 60 || this.type == 999) {
                    return
                }
                if (this.type != 2) {
                    var height = this.$common.getBtnHeight()
                    this.$emit("tabHeight", height)
                } else {
                    var height = this.$common.getHeight()
                    this.$emit("tabHeight", height)
                }
            })
        },
        // 自定义设计
        openFormDesign() { this.$emit("openFormDesign") },
    },
    mounted() {
        this.flag = false
        this.$nextTick(() => {
            console.log(this.tabShow);
            
            console.log(this.tabslist);
            if (this.tabslist.length > 0) {
                this.list = this.tabslist
                this.flag = true
                if (this.type == 999) {
                    this.tabslist1 = this.tabslist
                }
            } else {
                if (this.type == 999) {
                    this.tabslist1 = [{}]
                    this.$set(this.tabslist1[0], this.name, this.tabsTitle)
                    this.list = this.tabslist1
                    this.flag = true
                }
            }
        })
    }
}
</script>

<style scoped>
.v_tabs {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #f5f7fa;
    border-bottom: 1px solid #e4e7ed;
}

.v_tabsActive {
    background-color: #fff;
    border-bottom: 3px solid #e4e7ed;
    padding: 0 10px;
}

.v_tabs ul li {
    display: inline-block;
    padding: 5px 10px;
    font-size: 14px;
    cursor: pointer;
    border-right: 1px solid transparent;
    border-left: 1px solid transparent;
}

.v_tabs ul li span {
    display: block;
    padding: 0px 0;
}

.v_tabs ul li:hover span {
    color: #409eff;
}

.v_tabs .ul_btn li:hover {
    color: #409eff;
}

.v_tabs .ul_btn {
    margin-right: 10px;
}

.v_tabs .ul_btn li {
    padding: 5px 3px;
}

::v-deep .v_tabs .ul_btn .el-button--mini {
    padding: 7px 15px !important;
}

.actives {
    border-right: 1px solid #e4e7ed !important;
    border-left: 1px solid #e4e7ed !important;
    background-color: #fff;
    color: #409eff;
}

.v_tabsActive ul .actives {
    border-right: 1px solid transparent !important;
    border-left: 1px solid transparent !important;
    background-color: #fff;
    color: #409eff;
    border-bottom: 2px solid #409eff;
    margin-bottom: -2px;
}

.v_tabs_bottom {
    padding: 0 10px;
    padding-top: 10px;
}

.icons {
    font-size: 18px;
}

.czwd {
    overflow: auto;
}
</style>